import { Box, Chip, Typography } from "@mui/material";
import { ContasViewProps, mapDispatchToContasProps, mapStateToContasProps } from "../contas.controll";
import { ToolbarCad } from "../../../components/toolbar";
import { connect } from "react-redux";
import { Select as ViewList } from "../../../components/select";
import { GridColDef } from "@mui/x-data-grid";
import { formatData, formatMoney } from "../../../services/utils";
import { Contas } from "../contas.model";
import { ContasCadastro } from "./contas.cad";
import { navigationToContasView } from "../contas.router";
import { Paid } from "@mui/icons-material";
import { useState } from "react";
import ContaRecebimento from "./conta.recebimento";


export const situacaoColorContas = (value: any) => {
    switch (value) {
        case "pago":
            return "success";
        case "aberto":
            return "error"
        default:
            return "warning";
    }
}

const columns: GridColDef[] = [
    { field: 'created_at', headerName: 'Data', flex: 3, renderCell: (prm) => formatData(prm.value) },
    { field: 'valor', headerName: 'Valor', flex: 2, renderCell: (prm) => formatMoney(prm.value) },
    { field: 'situacao', headerName: 'Situacão', flex: 4, renderCell: (prm) => <Chip variant="filled" color={situacaoColorContas(prm.value)} label={prm.value} /> },
    { field: 'recebimentos', headerName: 'Recebido', flex: 2, valueGetter: (value, row: Contas) => formatMoney(row.recebimentos.map(val => val.valor).reduce((a, b) => a + b, 0)) },
]

function ContaDetalhe(props: ContasViewProps) {
    console.log("props", props)
    const { contasState, contasActions } = props
    const { rows, contaResumoSelected, loadingRows, msg, showAlert, status, row, changeList, tabValue, showCadModal } = contasState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal, setContaGroup, handleNovaConta, readContasDetalheByPessoa } = contasActions
    const [showPayButon, setShowPayButton] = useState(false)

    const handleAlterar = (value: Contas) => {
        set(value);
        setShowCadModal(true)
    }

    function Cadastro() {
        return ContasCadastro({
            ...props,
            tipo: tabValue === 0 ? "receber" : "pagar",
            handleCloseView: () => setShowCadModal(false),
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            width: "sm",
            heigth: "auto",
        })
    }



    return (
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", width: "100%" }}>
            <ToolbarCad
                handleBack={() => navigationToContasView()}
                buttonNovo={{
                    show: false,
                    title: ``,
                    onClick: () => { }
                }}
                title={contaResumoSelected.key.nome}
                elevation={2}
                positionToolBar="sticky"
                variantToobar="regular"
                buttonEnd={{
                    title: "Receber pagamento",
                    Icon: () => <Paid />,
                    onClick: () => setShowPayButton(true)

                }}
            />

            <ViewList
                displayWidth={window.innerWidth}
                title={`Total conta:  ${formatMoney(contaResumoSelected.value)}`}
                variantToobar="dense"
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={false}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                orderBy="situacao"
                columns={columns}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: () => handleNovaConta({ tipo: tabValue === 0 ? "receber" : "pagar", pessoa: contaResumoSelected.key })
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => readContasDetalheByPessoa(contaResumoSelected.key._id)
                }}
                ListItemTextPrimary={(row: Contas) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{formatData(row.created_at)}</Typography>
                        <Typography component={"span"}>{row.valor}</Typography>
                        <Chip variant="filled" color={situacaoColorContas(row.situacao)} label={row.situacao} />
                    </Box>
                }
                ViewBeforeGridList={() => <Cadastro />}

            />
            {showPayButon && (
                <ContaRecebimento />
            )}
        </Box>
    )
}

export default connect(mapStateToContasProps, mapDispatchToContasProps)(ContaDetalhe);